// src/app/credit-note-dialog/credit-note-dialog.component.ts
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';
import { DecimalFormatPipe } from 'app/pipes/decimal-company.pipe';
import { MonedaPipe } from 'app/pipes/moneda.pipe';

@Component({
  selector: 'app-credit-note',
  templateUrl: './credit-note.component.html',
   standalone: true,
    imports: [
      CommonModule,
      MatTableModule,
      MatDialogModule,
      MatButtonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      DecimalFormatPipe,
      CompanyCurrencyPipe
    ],
})
export class CreditNoteDialogComponent {
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[];
  totalPaying: number = 0;
  totalExtraPayment = 0;
  totalExtraCommission = 0;

  //Totales
  totalPayingFooter = 0;
  totalCommission = 0;
  totalRetainment = 0;
  totalSCR = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any[]) {
    // Add defensive validation
    if (!data || data.length === 0) {
      this.dataSource = new MatTableDataSource([]);
      this.displayedColumns = [];
      return;
    }
    
    this.dataSource = new MatTableDataSource(data);
    this.totalPaying = this.calculateTotalPaying(data);
    this.calculateTotals();
    //Verificar si existen extra pagos en los datos
    const hasExtraPayments = data.some(extraPayment =>
      (extraPayment.overpayment && extraPayment.overpayment > 0) ||
      (extraPayment.overCommission && extraPayment.overCommission > 0)
    );

    // Check both paymentMethod and paymentType to handle different payment scenarios
    const paymentMethodCode = data[0].paymentMethod?.code;
    const paymentTypeCode = data[0].paymentType?.code;

    // First check paymentMethod for POS and other payment methods
    if (paymentMethodCode === "MP00002") { // This code is for POS FICOHSA and similar payment methods
      const baseColumns = [
        "paymentMethod",
        "payingCredit",
        "commission",
        "taxRetainment",
        "payingSCR",
        //"extraPaymentTotal",
        //"extraPaymentFee"
      ];
      if(hasExtraPayments){
        this.displayedColumns = [
          ...baseColumns,
          "extraPaymentTotal",
          "extraPaymentFee"
        ];
      } else {
        this.displayedColumns = baseColumns;
      }
    } 
    // Then check paymentType for credit notes
    else if (paymentTypeCode === "TP0006") { // This code is for credit notes
      this.displayedColumns = [
        "paymentMethod",
        "bank",
        "accountNumber",
        "paying",
      ];
    }
    else if (paymentTypeCode === "TP00011") { // This code is for credit notes
      this.displayedColumns = [
        "paymentMethod",
        "operationNumber",
        "paying",
      ];
    }  
    // Default columns if no specific code matches
    else {
      this.displayedColumns = [
        "paymentMethod",
        "bank",
        "operationNumber",
        "paying",
      ];
    }
  }

  calculateTotalPaying(data: any[]): number {
    return data.reduce((sum, item) => sum + (item.pay || 0), 0);
  }



  calculateTotals() {
    this.totalPaying = this.dataSource.data.reduce((acc, cur) => acc + (cur.paying || 0), 0);
    this.totalCommission = this.dataSource.data.reduce((acc, cur) => acc + (cur.commission || 0), 0);
    this.totalRetainment = this.dataSource.data.reduce((acc, cur) => acc + (cur.taxRetainment || 0), 0);
    this.totalSCR = this.dataSource.data.reduce((acc, cur) => acc + (cur.payingSCR || 0), 0);
    //Totales para extra pagos 
    this.totalExtraPayment = this.dataSource.data.reduce((acc, cur) => acc + (cur.overpayment || 0), 0);
    this.totalExtraCommission = this.dataSource.data.reduce((acc, cur) => acc + (cur.overCommission || 0), 0);

  }

}
